/**
 * Checkout Module
 *
 * Gestisce la logica di checkout della sidebar:
 * - payment-data-builder: costruisce i dati di pagamento per il backend
 * - event-processors: processa gli eventi dai sotto-componenti
 */

export {
  prepare_discount_codes_payment_data,
  prepare_booking_payments_data
} from './payment-data-builder'

export {
  process_stripe_event,
  extract_discount_codes_data
} from './event-processors'